<template>
  <div
    class="content-field"
    :class="[wrapperStyle.class]"
    :style="[wrapperStyle.style]"
    :ref="name"
  >
    <slot name="content"></slot>
  </div>
</template>

<script>
export default {
  name: "ContentField",
  props: {
    value: {
      type: [String, Number],
    },
    name: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: false,
    },
    type: {
      type: String,
      required: false,
    },
    fieldType: {
      type: String,
      required: false,
    },
    showLabel: {
      type: Boolean,
      default: false,
      required: false,
    },
    placeholder: {
      type: String,
      required: false,
      default: "",
    },
    helperText: {
      type: String,
      required: false,
      default: "",
    },
    autoComplete: {
      type: Boolean,
      default: () => false,
    },
    wrapperStyle: {
      type: Object,
      required: false,
      default: () => ({}),
    },

    fieldStyle: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    icon: {
      type: String,
      required: false,
    },
    error: {
      type: String,
      required: false,
    },
    groupTag: {
      type: String,
      default: () => "",
    },
    hasError: {
      type: Boolean,
      default: false,
    },
    isDisabled: {
      type: Boolean,
      default: false,
      reuqired: false,
    },
  },
  data() {
    return {};
  },
  mounted() {
    this.addToGroup();
  },
  watch: {
    fieldValue: function () {
      this.allowOnlyNumber();
      this.updateValue();
    },
  },
  computed: {
    displayError() {
      if (this.isTyping) {
        if (this.hasError && this.error) {
          return "invalid";
        } else {
          return "valid";
        }
      }
    },
  },
  methods: {
    addToGroup() {
      if (this.groupTag) {
        const groupId = `#${this.groupTag}`;
        // console.log(`${this.name} => belongs to ${this.groupTag} group`);

        const group = document.querySelector(groupId);
        const groupItem = this.$refs[this.name];
        group.appendChild(groupItem);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>